import type { WidgetWriterProps } from '@/components/forms/components/form/writer/widgets/widget.type';
import { WorkflowGroup } from '@/components/forms/components/ui/workflowGroup/workflowGroup';
import { getSelectedGroupDetails } from '@/components/forms/utils/workflowContext';

export const GroupWidget = ({
  label = '',
  value = '',
  name,
  formContext
}: WidgetWriterProps) => {
  const selectedGroup = getSelectedGroupDetails(
    formContext?.workflowContext,
    value
  );

  return (
    <>
      <div
        className="mb-[3px] font-semibold text-base"
        data-cy={`reader-group-label-${name}`}
        data-testid="reader-group-label"
      >
        {label}
      </div>
      <div
        className="flex text-foreground text-sm"
        data-cy={`reader-group-info-${name}`}
        data-testid="reader-group-info"
      >
        {selectedGroup ? (
          <WorkflowGroup
            avatar={selectedGroup.avatar}
            name={selectedGroup.name || value}
          />
        ) : (
          value
        )}
      </div>
    </>
  );
};
